window.appLoaded.then(() => {
    $(document).ready(function () {
        InitDeleteWishlist();

        if (intAddressNo == 0) {
            var strParams = 'strWishlistArticles=' + GetLocalStorage('strWishlistArticles');

            // Getting wishlist items from local storage
            $.post(strAjaxPath + 'wishlist/wishlist-items.php', strParams, function (objResponse) {
                if (objResponse != '') {
                    $('div.wishlist-detail').html(objResponse);

                    // Init
                    InitDeleteWishlist();
                } else {
                    // Remove loader
                    $('div.wishlist-detail').html('');
                }
            }, 'html');
        } else {
            var strWishlistArticles = GetLocalStorage('strWishlistArticles');

            if (strWishlistArticles != '') {
                // Overlay
                $('main.content div.container').css('opacity', '0.3');

                // Loader
            $('main.content').addClass('relative');
                $('main.content').prepend('<div class="loader article-loader"></div>');

                var strParams = 'strWishlistArticles=' + strWishlistArticles;
                strParams += '&strType=copy';

                // Save wishlist from local storage to database
                $.post(strAjaxPath + 'wishlist/wishlist.php', strParams, function (objResponse) {
                    if (objResponse != '') {
                        // Save session storage
                        SetLocalStorage('strWishlistArticles', objResponse.articles);

                        // Reload page
                        window.location.reload();
                    }
                }, 'json');
            }
        }

        $('#new-list').click(function () {
            $('#frmWishlist').removeClass('hidden');
            $('#frmWishlist').addClass('flex');
            return false;
        });

        // Validate form to add new wishlist
        FormValidateAddWishlist($('form#frmWishlist'));
    });

    /** FUNCTIONS **/
    function InitDeleteWishlist() {
        $('button.delete-wishlist').click(function () {
            var objItem = $(this);
            var strWishlistArticles = GetLocalStorage('strWishlistArticles');

            var strParams = 'intArticleno=' + $(this).data('article');
            strParams += '&strType=delete';
            strParams += '&strWishlistArticles=' + strWishlistArticles;
            $.post(strAjaxPath + 'wishlist/wishlist.php', strParams, function (objResponse) {
                if (objResponse != '') {
                    // Save session storage
                    SetLocalStorage('strWishlistArticles', objResponse.articles);

                    // Remove item
                    objItem.closest('div.product').fadeOut().remove();
                }
            }, 'json');

            return false;
        });
    }
});
